export enum CallFlowActionType {
  CALL_USER = "CALL_USER",
  CALL_NUMBER = "CALL_NUMBER",
  VOICEMAIL = "VOICEMAIL",
  SAY_MESSAGE = "SAY_MESSAGE",
  PLAY_AUDIO = "PLAY_AUDIO",
  AI_AGENT = "AI_AGENT",
  MENU = "MENU",
  BUSINESS_HOURS = "BUSINESS_HOURS",
  RING_GROUP = "RING_GROUP",
  ROUND_ROBIN = "ROUND_ROBIN",
  ROUTE_TO_OWNER = "ROUTE_TO_OWNER",
  HANGUP = "HANGUP",
  DNC_OPT_OUT = "DNC_OPT_OUT",
}
